import * as React from 'react';
import './FullScreenStats.css';
import { useSelector } from 'react-redux';

import {
  selectMiningErrorPokersiteId,
  selectPlayerToShowStats,
  selectShowMiningError,
} from '../../selectors';

import BasicStats from '../BasicStats/BasicStats';
import PreflopStats from '../PreflopStats/PreflopStats';
import Flex from '../../../../components/Flex/Flex';
import PostflopStats from '../PostflopStats/PostflopStats';
import SummaryStats from '../SummaryStats/SummaryStats';
import HistoryStats from '../HistoryStats/HistoryStats';
import Chart from '../Chart/Chart';
import StatsHeader from '../StatsHeader/StatsHeader';
import Text from '../../../../components/Text/Text';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FullScreenStats = React.memo(() => {
  const { t } = useTranslation('translation');

  const playerToShowStats = useSelector(selectPlayerToShowStats);
  const showMiningError = useSelector(selectShowMiningError);
  const miningErrorPokersiteId = useSelector(selectMiningErrorPokersiteId);

  if (showMiningError) {
    return miningErrorPokersiteId === 1 ? (
      <div className="PageShell FullScreenStats">
        <aside className="SurfaceNote FullScreenStats__mining-error">
          <Flex vertical gap={16}>
            <Text size={3}>{t('mining_error_text_1')}</Text>
            <Text size={3}>{t('mining_error_text_2')}</Text>
            <Text size={3}>{t('mining_error_text_4')}</Text>
            <Text size={3}>
              C ценами можно ознакомиться в разделе <Link to="/subscription">подписка</Link>.
            </Text>
            <Link target="_blank" to="https://t.me/fishh_support">
              https://t.me/fishh_support
            </Link>
          </Flex>
        </aside>
      </div>
    ) : (
      <div className="PageShell FullScreenStats">
        <aside className="SurfaceNote FullScreenStats__mining-error">
          <Flex vertical gap={16}>
            <Text size={3}>
              {t('subscription_error_1')}{' '}
              <Link target="_blank" to="https://t.me/fishh_support">
                https://t.me/fishh_support
              </Link>
            </Text>
            <Text size={3}>
              C ценами можно ознакомиться в разделе <Link to="/subscription">подписка</Link>.
            </Text>
            <Text size={3}>{t('subscription_error_2')}</Text>
          </Flex>
        </aside>
      </div>
    );
  }

  if (!playerToShowStats) {
    return null;
  }

  return (
    <div className="PageShell FullScreenStats">
      <StatsHeader />
      <Flex gap={8} justify="flex-start" className="FullScreenStats__content">
        <Flex className="FullScreenStats--block" vertical gap={8}>
          <BasicStats />
          <PreflopStats />
          <PostflopStats />
          <SummaryStats />
        </Flex>
        <Flex className="FullScreenStats--block" vertical gap={8}>
          <Chart />
          <HistoryStats />
        </Flex>
      </Flex>
    </div>
  );
});

export default FullScreenStats;
